import {
  FETCH_TEMPLATE,
  FETCH_APPSTORE_DETAILS,
  UPDATE_APPSTORE_LOGO_LOCALLY,
  UPDATE_APPSTORE_OTHERIMAGES,
  FETCH_EMAIL_LOG,
  FETCH_EMAIL_LOG_CONTENTS,
  BILLING_ACTIVEUSER_LIST,
  LANGUAGE_ADD_MODAL,
  FETCH_EVENT_LANGUAGE,
  LANGUAGE_CSV_IMPORT_MODAL,
  INTEGRATION_MODAL,
  FETCH_ALL_EMAIL_LOG,
} from "SettingActions";

export function templateReducers(state = [], action) {
  switch (action.type) {
    case FETCH_TEMPLATE:
      return action.payload;
    default:
      return state;
  }
}

export function appstoreDetails(state = [], action) {
  switch (action.type) {
    case FETCH_APPSTORE_DETAILS:
      return action.payload;
    default:
      return state;
  }
}

export function appstoreLocalLogoReducer(state = null, action) {
  switch (action.type) {
    case UPDATE_APPSTORE_LOGO_LOCALLY:
      return action.payload;
    default:
      return state;
  }
}

export function appstoreOtherImagesReducer(
  state = [
    { position: 0, image: "" },
    { position: 1, image: "" },
    { position: 2, image: "" },
    { position: 3, image: "" },
    { position: 4, image: "" },
  ],
  action
) {
  switch (action.type) {
    case UPDATE_APPSTORE_OTHERIMAGES:
      return action.payload;
    default:
      return state;
  }
}

export function emailLogReducers(state = [], action) {
  switch (action.type) {
    case FETCH_EMAIL_LOG:
      return action.payload;
    default:
      return state;
  }
}
export function emailLogContentReducers(state = [], action) {
  switch (action.type) {
    case FETCH_EMAIL_LOG_CONTENTS:
      return action.payload;
    default:
      return state;
  }
}

export const activeUsrsDetails = (state = {}, action) => {
  switch (action.type) {
    case BILLING_ACTIVEUSER_LIST:
      return action.payload;
      break;
    default:
      return state;
      break;
  }
};

export const languageAddModalReducer = (state = {}, action) => {
  switch (action.type) {
    case LANGUAGE_ADD_MODAL:
      return action.payload;
      break;
    default:
      return state;
      break;
  }
};

export const languageCsvImportModalReducer = (state = {}, action) => {
  switch (action.type) {
    case LANGUAGE_CSV_IMPORT_MODAL:
      return action.payload;
      break;
    default:
      return state;
      break;
  }
};

export const eventLanguages = (state = [], action) => {
  switch (action.type) {
    case FETCH_EVENT_LANGUAGE:
      return action.payload;
      break;
    default:
      return state;
      break;
  }
};

export const integrationModalReducer = (state = {}, action) => {
  switch (action.type) {
    case INTEGRATION_MODAL:
      return action.payload;
      break;
    default:
      return state;
      break;
  }
};

export function allEmailLog(state = [], action) {
  switch (action.type) {
    case FETCH_ALL_EMAIL_LOG:
      return action.payload;
    default:
      return state;
  }
}
